import React, { useState, useEffect, useRef } from 'react';

export default function Filters({ filters, order, changeFilters, searchFilters }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  // Store a stable reference to searchFilters
  const searchFiltersRef = useRef(searchFilters);

  useEffect(() => {
    searchFiltersRef.current = searchFilters;
  }, [searchFilters]);

  // Update debounced search term after a delay
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500); // delay of 500ms

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // Call searchFilters whenever debouncedSearchTerm changes
  useEffect(() => {
      searchFiltersRef.current(debouncedSearchTerm);
    
  }, [debouncedSearchTerm]);

  return (
    <div className="flex justify-end sm:justify-between mx-auto max-w-[1240px] w-full px-7 inter-600 font-[600]   text-gray-400 text-[11px] sm:text-[12px]  mt-8  pb-3  pb-8">
      <div className='hidden sm:flex'>
        {/* Search Bar */}
        <div className='flex gap-3 items-center'>
          <div className='relative flex items-center'>
            <img
              src="/searchIcon.svg"
              alt="Search Icon"
              className="absolute left-3 w-3 h-3 text-gray-500" 
            />
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search..."
  className="pl-10 py-[7px] shadow-[4px_4px_8px_rgba(255,255,255,0.03)] px-8 lg:pr-20 border font-[400] border-gray-500/30 hover:bg-white/5 bg-white/0 transition-all duration-300 focus:border-gray-500/75 text-[11px] rounded-[8px] placeholder-gray-500 text-gray-300 placeholder:text-[12px] focus:outline-none focus:ring-0 appearance-none"
            />
          </div>
        </div>
      </div>
      <div className="flex mr-6 sm:mr-8 lg:mr-0 gap-[25px]  sm:gap-[60px] md:gap-[84px] lg:gap-[113px] xl:gap-[115px]">
        {/* Price Button */}
        <button
          onClick={() => changeFilters("price")}
          className="flex items-center gap-[5px] hover:text-white/80"
        >
          <div className={`${filters === "price" ? "text-white/80" : ""} `}>
            Price
          </div>
          <div className='w-[11px]'>
            {filters === "price" && (
            <img
              src={
                order === "ASC"
                  ? "/ascending.png"
                  : "/descending2.png"
              }
              alt="filter arrow"
              className="w-[7px] h-[8px]"
            />
          )}</div>
        </button>

        {/* Change Button */}
        <button
          onClick={() => changeFilters("change24h")}
          className="flex items-center gap-[5px] hover:text-white/80 "
        >
          <div className={`${filters === "change24h" ? "text-white/80" : ""}`}>
            Change
          </div>
         <div className='w-[11px]'>
            {filters === "change24h" && (
            <img
              src={
                order === "ASC"
                  ? "/ascending.png"
                  : "/descending2.png"
              }
              alt="filter arrow"
              className="w-[7px] h-[8px]"
            />
          )}</div> 
        </button>

        {/* Volume Button */}
        <button
          onClick={() => changeFilters("volume")}
          className=" items-center gap-[5px] hover:text-white/80 hidden sm:flex"
        >
          <div className={`${filters === "volume" ? "text-white/80" : ""}`}>
            24h Volume
          </div>
          <div className='w-[11px]'>
            {filters === "volume" && (
            <img
              src={
                order === "ASC"
                  ? "/ascending.png"
                  : "/descending2.png"
              }
              alt="filter arrow"
              className="w-[7px] h-[8px]"
            />
          )}</div>
        </button>

        {/* FDV Button */}
        <button
          onClick={() => changeFilters("fdv")}
          className="flex items-center gap-[5px] text-gray-400 hover:text-white/80"
        >
          <div className={`${filters === "fdv" ? "text-white/80" : ""}`}>
            FDV
          </div>
          <div className='w-[11px]'>
            {filters === "fdv" && (
            <img
              src={
                order === "ASC"
                  ? "/ascending.png"
                  : "/descending2.png"
              }
              alt="filter arrow"
              className="w-[7px] h-[8px]"
            />
          )}</div>
        </button>

        {/* APY Button */}
        <button
          onClick={() => changeFilters("apy")}
          className="hidden lg:flex items-center gap-[5px] text-gray-400 hover:text-white/80"
        >
          <div className={`${filters === "apy" ? "text-white/80" : ""}`}>
            APY
          </div>
          <div className='w-[11px]'>
            {filters === "apy" && (
            <img
              src={
                order === "ASC"
                  ? "/ascending.png"
                  : "/descending2.png"
              }
              alt="filter arrow"
              className="w-[7px] h-[8px]"
            />
          )}</div>
        </button>
      </div>
    </div>
  );
}
